import * as React from 'react';
import { Link } from 'react-router-dom';
import { DeluxeContext } from './';
import { ClickElement } from '../form';

export const DeluxeFooter = () => {
  return (
    <DeluxeContext.Consumer>
      {({ onClickHandlers }) => {
        const { surveyLink, goToPage } = onClickHandlers;
        return (
          <footer>
            <section>
              <ClickElement
                secondary
                ElementType={Link}
                type="button"
                text='Nee, opzouten.'
                to='/'
                testId='footerNoButton'
                onClick={() => surveyLink({
                  action: 'FeatureOverviewPage',
                  label: 'NoButton',
                })
                }               
              />
              <ClickElement
                primary
                ElementType="button"
                type="button"
                text='Ja, dit wil ik!'
                testId='footerYesButton'
                onClick={() => goToPage('payment', {
                  action: 'FeatureOverviewPage',
                  label: 'YesButton',
                })}
              />        
            </section>
          </footer>
        );
      }}
    </DeluxeContext.Consumer>
  );
};